module.exports = __webpack_public_path__ + "img/align-2--active.f2d3fd66.svg";